// @ts-nocheck
import { useEffect } from "react";

const useDisableScrollOnNumberInput = () => {
  useEffect(() => {
    const handleWheel = (e) => {
      const activeEl = document.activeElement;
      if (activeEl && activeEl.type === "number") {
        e.preventDefault();
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);
};

export default useDisableScrollOnNumberInput;